import { render, staticRenderFns } from "./registered.vue?vue&type=template&id=5f515a8e&"
import script from "./registered.vue?vue&type=script&lang=ts&"
export * from "./registered.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports